.section {
  margin-top: var(--tuna-spacing-2);
}

.heading {
  margin: 0;
}

.list {
  list-style: none;
  margin: 0;
  padding: 0;
}
